<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="700px" data-app ligth persistent>
      <slot name="showButtonSlot" slot="activator"></slot>
      <v-card>
        <v-card>
          <slot name="modal_title"></slot>
        </v-card>
        <v-card-text>
          <v-container grid-list-md>
            <p class="indigo--text darken-4 pa-0 ma-0 font-weight-bold">{{ $t('OIB_info.info1').toUpperCase() }}</p>
            <p class="indigo--text darken-4 pa-0 ma-0">{{ $t('OIB_info.info2') }}</p>
            <p class="indigo--text darken-4 pa-0 ma-0">{{ $t('OIB_info.info3') }}</p>
            <p class="indigo--text darken-4 pa-0 ma-0">{{ $t('OIB_info.info4') }}</p>

            <v-form ref="oibform">
              <ProgressBar :loading="spremamPodatke" color="deep-purple accent-4" />
              <v-text-field v-model="oib"
                            label="OIB"
                            :rules="oibRules"
                            required></v-text-field>
            </v-form>

          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="hide">{{$t('btnCancel')}}</v-btn>
          <v-spacer></v-spacer>
          <!--<slot name="modal_footer"></slot>-->
          <v-btn color="blue darken-1" flat @click="spremiPodatke">{{$t('btnSave')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>


<script>
  import { mapState, mapActions } from 'vuex'
  import ProgressBar from '../../Common/Components/MyToolbarProgressBar.vue';

  export default {
    name: 'UnosOIBa',
    props: {
      povratnaFunkcija: {
        type: Function, default: function () { }
      }
    },

    components: {
      ProgressBar
    },

    computed: {
      ...mapState('app', ['currentUser']),
      oibRules() {
        const rules1 = []
        //if (this.oib) {
        const rule = v => this.ProvjeriOIB(v) == true || this.$t('OIB_info.greska_OIB')
        rules1.push(rule)
        //}
        return rules1
      }
    },

    watch: {
      oib: 'validateField'
    },

    methods: {
      ...mapActions('app', ['setTokenWithExpiration']),
      validateField() {
        return this.$refs.oibform.validate();
      },

      show() {
        this.oib = this.getOibFromStore()
        this.dialog = true;
      },

      getOibFromStore() {
        if (this.currentUser.OIB && this.currentUser.OIB.length == 11)
          return this.currentUser.OIB;
        else
          return ''
      },

      hide() {
        this.dialog = false;
      },

      spremiPodatke() {
        var isFormValid = this.validateField();

        if (isFormValid) {
          var isOibOk = this.ProvjeriOIB(this.oib);

          if (isOibOk) {
            this.spremiUBazu()
          } else {
            this.$displayWarning(this.$t('OIB_info.greska_OIB'));
          }
        }
      },

      spremiUBazu() {
        this.spremamPodatke = true;
        var self = this;
        // Tek nakon spremanja u bazu, ova poruka u u store dodavanje
        var oibdata = { OIB: this.oib };
        this.$fetchDataPromise('/api/Base/UnesiOIBPolaznika', oibdata)
          .then(x => {
            this.spremamPodatke = false;

            if (x != null && x.length > 0) {
              this.odabranaUslugaKljuc = x[0].DDLKljuc;
              self.odabranaPodruznica = x[0].PodruznicaId != null ? x[0].PodruznicaId : 1;
            }
            // dodam izmjene u store
            var updatedUser = this.currentUser;
            updatedUser.OIB = this.oib;
            this.setTokenWithExpiration(updatedUser);

            this.dialog = false;
            this.$displaySuccess(this.$t('OIB_info.uspjeh_OIB'));
            setTimeout(function () {
              self.povratnaFunkcija();
            }, 3000)

          })
          .catch(x => { this.spremamPodatke = false; this.$displayError(x) });

      },

      ProvjeriOIB(OIB) {

        // Duljina mora biti 11 znakova.
        if (OIB.length != 11)
          return false;

        // Svaki znak mora biti broj (usput i razdvojim znamenke).
        var znamenke = []; //new byte[11];

        for (var i = 0; i < 11; i++) {

          if (this.isNumeric(OIB[i])) {
            znamenke.push(OIB[i]);
          } else {
            return false;
          }
        }

        // Implementacija ISO 7064.
        var ostatak = 10;
        for (var i = 0; i <= 9; i++) {
          var zbroj = ostatak + parseInt(znamenke[i]);
          var medjuostatak = zbroj % 10 != 0 ? zbroj % 10 : 10;
          var medjuostatakDupli = medjuostatak * 2;
          ostatak = medjuostatakDupli % 11;
        }
        var kontrolnaZnamenka = (ostatak == 1 ? 0 : 11 - ostatak);

        if (kontrolnaZnamenka != znamenke[10])
          return false;

        return true;
      },

      isNumeric(value) {
        return !isNaN(value);
      }

    },

    mounted() {

    },


    data: () => ({
      text: '',
      dialog: false,
      oib: '',
      spremamPodatke: false
    })
  }
</script>



// WEBPACK FOOTER //
// VueSrc/Exams/exam_common/UnosOIBa.vue